import ServiceCostsList from './components/List'

const ServiceCosts: React.FC = () => {
    return <ServiceCostsList />
}

export default ServiceCosts
